import Cookies from 'js-cookie'

const TokenKey = 'loginOpenId'

const DeviceIdKey = 'yunpanDeviceId'

const ChannelKey = 'channel'

const UserId = 'userId'

const CipherText = "cipherText";

const HeJiaInfo = "heJiaInfo";

import { getOpenid } from '@/api/login'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}


export function getDeviceId() {
  return Cookies.get(DeviceIdKey)
}

export function setDeviceId(deviceId) {
  return Cookies.set(DeviceIdKey, deviceId)
}

export function removeDeviceId() {
  return Cookies.remove(DeviceIdKey)
}

export function getChannel() {
  return Cookies.get(ChannelKey)
}

export function setChannel(channel) {
  return Cookies.set(ChannelKey, channel)
}

export function removeChannel() {
  return Cookies.remove(ChannelKey)
}

export function getUserId() {
  return Cookies.get(UserId)
}

export function setUserId(userId) {
  return Cookies.set(UserId, userId)
}

export function removeUserId() {
  return Cookies.remove(UserId)
}

export function getCipherText() {
  return Cookies.get(CipherText);
}

export function setCipherText(cipherText) {
  return Cookies.set(CipherText, cipherText);
}

export function getHeJiaInfo() {
  return Cookies.get(HeJiaInfo);
}
export function setHeJiaInfo(heJiaInfo) {
  return Cookies.set(HeJiaInfo, heJiaInfo);
}

export function removeCipherText() {
  return Cookies.remove(CipherText);
}

export function getUrlKey(name) {//获取url 参数
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
}

export function getCodeApi(sourceUrl) {//获取code
  // var sourceUrl = this.$route.query.sourceUrl;
  // let urlNow = encodeURIComponent(window.location.href);
  let path = '';
  if (window.location.hash) {
    path = window.location.hash
  } else {
    path = window.location.pathname;
  }
  let redirectUrl = encodeURIComponent(process.env.WX_AUTH_API + path + "?sourceUrl=" + sourceUrl
  );
  let scope = 'snsapi_userinfo';    //snsapi_userinfo
  let appid = process.env.WECHAT_APP_ID;
  let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=${scope}&state=wechat#wechat_redirect`;
  window.location.replace(url);
}

//注意代码放置位置
export function login() {
  let code = getUrlKey("code");//获取url参数code
  if (code) { //拿到code， code传递给后台接口换取opend
    getOpenid(code).then(res => {
    }).catch(res => { })
  } else {
    getCodeApi();
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js